<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    />

    <el-dialog title="详情" :visible.sync="dialogVisibleLog" width="50%">
      <span class="info-class">
        <div class="item">
          <div class="left">订单号</div>
          <div class="right">{{ info.trade_no }}</div>
        </div>
        <div class="item">
          <div class="left">微信支付单号</div>
          <div class="right">{{ info.transaction_id }}</div>
        </div>
        <div class="item">
          <div class="left">微信分账单号</div>
          <div class="right">{{ info.wx_fz_order_id }}</div>
        </div>
        <div class="item">
          <div class="left">分账单号</div>
          <div class="right">{{ info.out_order_no }}</div>
        </div>
        <div class="item">
          <div class="left">创建人</div>
          <div class="right">{{ info.create_by }}</div>
        </div>

        <div class="item">
          <div class="left">状态</div>
          <div class="right" v-if="info.status != 'PROCESSING'">分账完成</div>
          <div class="right" v-else>处理中</div>
        </div>
        <div class="item">
          <div class="left">创建时间</div>
          <div class="right">{{ info.create_time }}</div>
        </div>
        <div class="item">
          <div class="left">更新时间</div>
          <div class="right">{{ info.update_time }}</div>
        </div>
        <div class="credentials">
          <div class="credentials-body">
            <div class="credentials-item ">
              <div class="item-left">姓名</div>
              <div class="item-right">金额</div>
              <div class="item-right">说明</div>
            </div>
            <div
              class="credentials-item"
              v-for="item in info.receivers"
              :key="item.id"
            >
              <div class="item-left">{{ item.name }}</div>
              <div class="item-right">{{ item.amount }}</div>
              <div class="item-right">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as routing from "@/api/routing/link.js";
// import * as member from "@/api/product/member.js";
import * as userGroup from "@/api/product/user-group.js";
import * as dept from "@/api/dept/dept.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      searchDesc: {
        trade_no: {
          label: "订单号",
          type: "input"
        },
        status: {
          label: "分账状态",
          type: "select",
          options: [
            {
              text: "分账完成",
              value: "FINISHED"
            },
            {
              text: "处理中",
              value: "PROCESSING"
            }
          ]
        }
      },
      info: 0,
      formData: {},
      rules: {},
      dialogVisible: false,
      dialogFormVisible: false,
      dialogVisibleLog: false,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "会员",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "member_name",
            label: "会员名称"
          },
          // {
          //   prop: "receivers",
          //   label: "分账接收方",
          //   type: "input",
          //   // 1普通用户 2会员用户 3分销商用户
          //   show: "tag",
          //   tagtype: [],
          //   hide: true,
          //   click: (id, row, index) => {
          //     this.dialogVisibleLog = true;
          //     this.index = index;
          //   }
          // },
          {
            prop: "transaction_id",
            label: "微信交易单号",
            type: "input",
            hide: true
          },
          {
            prop: "out_order_no",
            label: "商户分账单号",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            hide: true
          },

          {
            prop: "wx_fz_order_id",
            label: "微信分账单号",
            hide: true
          },
          {
            prop: "create_by",
            label: "创建用户",
            type: "input",
            hide: true
          },
          {
            prop: "status",
            label: "状态",
            type: "input",
            show: "tag",
            // 1普通会员 2正式会员 3付费会员
            tagtype: [
              {
                text: "分账完成",
                value: "FINISHED"
              },
              {
                text: "处理中",
                value: "PROCESSING"
              }
            ],
            hide: true
          },
          {
            prop: "create_time",
            label: "创建时间"
          },
          {
            prop: "update_time",
            label: "更新时间"
          }
        ],
        btnList: [
          {
            name: "详情",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              // this.info = this.tableData[index];
              this.dialogVisibleLog = true;

              routing.routingLogInfo.r({ id: id }).then(res => {
                this.info = res;
                console.log(this.info, "详情");
              });
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  mounted() {
    dept.getDeptTree.r().then(res => {
      this.formDesc.dept_id["options"] = res;
    });
  },
  methods: {
    downloadIamge(imgsrc, name) {
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    // handleSubmit(form) {
    //   member.editMember.r(form).then(res => {
    //     this.chushihua("创建成功");
    //   });
    // },
    chushihua(text) {
      if (text) this.$message.success(text);
      this.formData = {};
      this.dialogFormVisible = false;
      this.getlist();
    },
    handleSuccess() {},
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }

      routing.routingLogs.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
        console.log(res, "555555555555");
      });
    }
  }
};
</script>
<style scoped lang="scss">
.info-class {
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 50%;
    display: flex;
    line-height: 40px;
    font-size: 14px;
    // &:nth-child(1) {
    //   border-top: 1px solid #dcdfe6;
    // }
    // border-bottom: 1px solid #dcdfe6;
    .left {
      font-weight: 500;
      font-size: 13px;
      padding-left: 10px;
      margin-right: 10px;
      width: 90px;
    }
    .right {
      width: calc(100% - 100px);
      color: #303133;
    }
  }

  .credentials {
    margin-top: 10px;
    line-height: 35px;
    width: 100%;
    .credentials-body {
      width: 100%;
      .credentials-item {
        width: 100%;
        display: flex;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }

        .item-left {
          width: 50%;
          padding-left: 10px;
        }
        .item-right {
          padding-left: 10px;
          width: 50%;
        }
      }
    }
  }
}
</style>
